import commonService from "./common-service";

class UnitCostService {
  async getUnitCostData(month, year) {
    try {
      //todo
      if (!month || !year) return [];
      let response = await commonService.getFromServer(
        "EOM/UnitCost?year=" + year + "&month=" + month,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createData(params) {
    try {
      let response = await commonService.postToServer("EOM/UnitCost", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/UnitCost/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitMultiData(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/UnitCost/Multi",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(month, year) {
    try {
      await commonService.downloadFromServer(
        "EOM/UnitCost/Download?year=" + year + "&month=" + month,
        {
          fileName: "UnitCost.xlsx",
        }
      );
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateData(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/UnitCost/" + params?.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getData(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/UnitCost/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteData(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/UnitCost/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting data");
      }
    } catch (e) {
      throw new Error("Error deleting data");
    }
  }
}
export default new UnitCostService();
